/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { AvatarDropdown } from "./AvatarDropdown";
import { Logo } from "./Logo";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import { adminRoutes, routes } from "../routes";
import { useAuth } from "../context/auth-context";
import { useQueryCache } from "react-query";

const adminNavItems = [
  { label: "Module reports", to: adminRoutes.moduleReports.path },
  { label: "Users Management", to: adminRoutes.usersManagement.path },
  { label: "Crawler Options", to: adminRoutes.crawlerOptions.path },
  { label: "Stop Words List", to: adminRoutes.stopWordsList.path },
  { label: "Free User Settings", to: adminRoutes.freeUserSettings.path },
  { label: "Regex Presets", to: adminRoutes.regexPresets.path },
  { label: "Notifications", to: adminRoutes.notifications.path },
  { label: "API Scheduler Checks", to: adminRoutes.apiSchedulerChecks.path },
];

const desktopLinkClass =
  "ml-8 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium leading-5 text-gray-900 focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out";
const mobileLinkClass =
  "block border-l-4 border-transparent pl-3 pr-4 py-2 text-base font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800 focus:border-gray-300 focus:bg-gray-50 focus:text-gray-800 focus:outline-none transition duration-150 ease-in-out";
const mobileActiveClass = "border-indigo-500 bg-indigo-50 text-indigo-700";

export const AdminNavigation: React.FC = () => {
  const { logout } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const queryCache = useQueryCache();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileMenuOpen) {
      return;
    }
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [mobileMenuOpen]);

  const handleLogout = (event: React.SyntheticEvent) => {
    event.preventDefault();
    logout();
    queryCache.clear({});
    history.replace("/login");
  };

  // Phone: the bar stays at the top while the page scrolls. Desktop stays in flow.
  return (
    <nav className="sticky top-0 z-30 bg-white shadow-sm sm:relative sm:top-auto sm:z-20">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              {/*<Link to={adminRoutes.adminDashboard.path}>*/}
              <Logo />
              {/*</Link>*/}
            </div>
            <div className="hidden sm:ml-6 sm:flex">
              {adminNavItems.map((item) => (
                <NavLink
                  key={item.label}
                  activeClassName="border-indigo-500"
                  to={item.to}
                  className={desktopLinkClass}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            <a
              className="p-1 border-2 border-transparent text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100 transition duration-150 ease-in-out"
              aria-label="email"
              href={`mailto:support@searchanalyzer.io?subject=searchanalyzer%20feedback&body=Hi%20Stephan%2C%0D%0A%0D%0AI'm%20currently%20on%20%7B${window.location.href}%7D%20and%20have%20the%20following%20feedback%20to%20share%20with%20you%3A`}
            >

              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
              </svg>

              {/*<svg
                className="h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                />
              </svg>*/}
            </a>
            <div className="ml-3 ">
              <AvatarDropdown />
            </div>
          </div>
          <div className="-mr-2 flex items-center sm:hidden">
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
              aria-label={mobileMenuOpen ? "Close main menu" : "Open main menu"}
              aria-expanded={mobileMenuOpen}
              aria-controls="admin-mobile-menu"
              onClick={() => setMobileMenuOpen((open) => !open)}
            >
              <svg
                className={`${mobileMenuOpen ? "hidden" : "block"} h-6 w-6`}
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <svg
                className={`${mobileMenuOpen ? "block" : "hidden"} h-6 w-6`}
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div
        id="admin-mobile-menu"
        className={`${mobileMenuOpen ? "block" : "hidden"} max-h-screen overflow-y-auto sm:hidden`}
      >
        <div className="pt-2 pb-3">
          {adminNavItems.map((item, index) => (
            <NavLink
              key={item.label}
              to={item.to}
              activeClassName={mobileActiveClass}
              className={`${index === 0 ? "" : "mt-1 "}${mobileLinkClass}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
        </div>
        <div className="border-t border-gray-200 pt-4 pb-3">
          <Link
            to={routes.account.path}
            className="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800 focus:bg-gray-100 focus:text-gray-800 focus:outline-none transition duration-150 ease-in-out"
            onClick={() => setMobileMenuOpen(false)}
          >
            Account
          </Link>
          <button
            type="button"
            onClick={handleLogout}
            className="mt-1 block w-full px-4 py-2 text-left text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800 focus:bg-gray-100 focus:text-gray-800 focus:outline-none transition duration-150 ease-in-out"
          >
            Sign out
          </button>
        </div>
      </div>
    </nav>
  );
};
